import React, {useEffect, useState} from 'react';
import Layout from '../components/Layout';
import {api} from '../../api';

export default function Announcements() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(null);

  const load = () => api('/hcm/announcements').then(r => r.json()).then(setItems).catch(() => {});
  useEffect(load, []);

  const handleSave = async (e) => {
    e.preventDefault();
    if (form.id) await api(`/hcm/announcements/${form.id}`, {method: 'PUT', body: JSON.stringify(form)});
    else await api('/hcm/announcements', {method: 'POST', body: JSON.stringify(form)});
    setForm(null); load();
  };

  return (
    <Layout>
      <div className="bg-white rounded-lg shadow">
        <div className="p-4 md:p-6 border-b flex justify-between items-center">
          <h1 className="text-2xl font-bold text-gray-900">Announcements</h1>
          <button onClick={() => setForm({title: '', body: '', published: false})} className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 text-sm">New Announcement</button>
        </div>
        {items.length === 0 ? (
          <div className="text-center py-8 text-gray-500">No announcements yet.</div>
        ) : (
          <div className="divide-y">
            {items.map(a => (
              <div key={a.id} className="p-4 md:p-6">
                <div className="flex items-start justify-between">
                  <div>
                    <div className="flex items-center gap-3 mb-1">
                      <h3 className="font-semibold text-gray-900">{a.title}</h3>
                      <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${a.published ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-600'}`}>
                        {a.published ? 'Published' : 'Draft'}
                      </span>
                    </div>
                    {a.body && <p className="text-gray-600 text-sm whitespace-pre-wrap">{a.body}</p>}
                    <p className="text-xs text-gray-400 mt-2">{new Date(a.createdAt).toLocaleDateString()}</p>
                  </div>
                  <div className="flex gap-2 flex-shrink-0 ml-4">
                    <button onClick={async () => { await api(`/hcm/announcements/${a.id}/publish`, {method: 'POST'}); load(); }}
                      className="text-sm text-gray-500 hover:text-indigo-600">{a.published ? 'Unpublish' : 'Publish'}</button>
                    <button onClick={() => setForm({id: a.id, title: a.title, body: a.body || '', published: a.published})}
                      className="text-sm text-gray-500 hover:text-indigo-600">Edit</button>
                    <button onClick={async () => { await api(`/hcm/announcements/${a.id}`, {method: 'DELETE'}); load(); }}
                      className="text-sm text-gray-500 hover:text-red-600">Delete</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {form && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={() => setForm(null)}>
          <form onSubmit={handleSave} onClick={e => e.stopPropagation()} className="bg-white rounded-lg shadow-xl p-6 w-full max-w-lg space-y-4">
            <h3 className="text-lg font-semibold text-gray-900">{form.id ? 'Edit' : 'New'} Announcement</h3>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Title *</label>
              <input required value={form.title} onChange={e => setForm({...form, title: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 outline-none" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Body</label>
              <textarea value={form.body} onChange={e => setForm({...form, body: e.target.value})} rows={4}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 outline-none" />
            </div>
            <div className="flex justify-end gap-3">
              <button type="button" onClick={() => setForm(null)} className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg">Cancel</button>
              <button type="submit" className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700">Save</button>
            </div>
          </form>
        </div>
      )}
    </Layout>
  );
}
